<template src="./StockAlertModal.html"/>
<style lang='scss' scoped src="./StockAlertModal.scss"/>

<script>

import {
  SfButton,
  SfModal,
  SfInput,
  SfAlert,
  SfBar
} from '@storefront-ui/vue';
import OrkRecaptcha from "@/components/Ork/OrkRecaptcha";
import Api from "@/api/Api";

export default {
  name: 'StockAlertModal',
  components: {
    SfBar,
    SfAlert,
    SfButton,
    SfInput,
    SfModal,
    OrkRecaptcha
  },

  data() {
    return {
      loading: false,
      error: null,
      valid: false,
      submitted: false,
      email: "",
      emailBlur: true
    };
  },
  computed: {
    isStockAlertModal: {
      get() {
        return this.$store.getters.isStockAlertModal
      }
    },
  },


  methods: {
    executeRecaptcha() {
      this.$refs.recaptchaStockAlert.execute()
    },
    validate() {

      this.emailBlur = false;

      if (
          this.validEmail(this.email)
      ) {
        this.valid = true;
      }
    },
    validEmail(email) {
      const regex = /(.+)@(.+){2,}\.(.+){2,}/
      const hasWhiteSpace = /\s/;
      if (regex.test(email.toLowerCase()) && !hasWhiteSpace.test(email.toLowerCase())) {
        return true;
      } else {
        return false;
      }
    },
    toggleStockAlertModal() {
      this.$store.dispatch('toggleStockAlertModal', {open: false, products: null})
    },
    submitStockAlert(token) {

      const onComplete = () => {
        if (!this.error || this.error.status === 200) {
          this.loading = false;
        } else {
          this.loading = false;
        }
      };

      const onError = (e) => {
        this.error = e;
        this.loading = false;
      };
      this.validate()
      if (this.valid) {
        this.loading = true;
         Api.platform.checkRecaptcha(token).then((data) => {
        this.$emit('submit', {form: {email: this.email}, onComplete, onError});
           }).catch((e)=>{
              // console.error(e);

         }).finally(()=>{
           this.loading = false;
         })
      }
    }
  }
};
</script>


